export default "__VITE_ASSET__36d5be56__"